export const replaceIncentivesMarketContractTag = (
  html: string,
  tagTitle: string,
  value: string
): string => {
  const regex = new RegExp(`\\{+${tagTitle}\\}+`, 'g');
  return html.replace(regex, value);
};

export const replaceIncentivesMarketContractUnitTag = (
  html: string,
  currentTag: string,
  legacyTag: string,
  value: string
): string => {
  let result = replaceIncentivesMarketContractTag(html, currentTag, value);
  result = replaceIncentivesMarketContractTag(result, legacyTag, value);
  return result;
};
